import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

// Handles Emergent OAuth session_id in URL hash — exchanges with backend, then redirects.
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) {
      navigate("/dashboard", { replace: true });
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        navigate("/dashboard", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-script text-primary-ub text-3xl">A moment…</div>
        <p className="text-ub-2 mt-2">Welcoming you in.</p>
      </div>
    </div>
  );
}
